import { PaymentTypes } from '../../types';

const initialState = {
  balance: 0,
  balance_in_transaction: 0
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PaymentTypes.SAVE_THERAPIST_ACCOUNT_INFO:
      return { ...state, ...payload };
    default:
      return state;
  }
};
